import styled from 'styled-components';

export const AccidentsPageStyles = styled.section`
  padding: 1.5rem 0;
`;

export const PageHeader = styled.div`
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  h2 {
    color: #333;
    font-weight: 600;
    font-size: 1.75rem;
    margin: 0;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const AccidentCard = styled.li`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
    border-color: #00a651;
  }

  .accident-content {
    flex: 1;
  }

  .customer-name {
    color: #333;
    font-weight: 600;
    font-size: 1rem;
    margin-bottom: 0.35rem;
  }

  .accident-details {
    color: #666;
    font-size: 0.95rem;
    line-height: 1.4;

    .detail-row {
      margin-bottom: 0.35rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .info-chips-row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.35rem;
    }

    .detail-label {
      font-weight: 500;
      color: #555;
    }
  }

  .created-date {
    color: #999;
    font-size: 0.8rem;
    margin-top: 0.5rem;
    font-weight: 400;
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.2rem 0.65rem;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 900;
  background: #f5f5f5;
  color: #616161;
  border: 1.5px solid #616161;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 0.2rem;
`;

export const ActionButton = styled.span`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  background: linear-gradient(135deg, #00a651 0%, #008a44 100%);
  color: white;
  border: none;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 166, 81, 0.3);
  }

  @media (max-width: 1300px) {
    padding: 0.65rem 1.35rem;
    font-size: 0.8rem;

    
  }
`;

export const PostSaleButton = styled.button`
  background: linear-gradient(135deg, #00a651 0%, #008a44 100%);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 166, 81, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const FilterCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  position: sticky;
  top: 20px;

  h5 {
    color: #333;
    font-weight: 600;
    margin-bottom: 1.25rem;
    font-size: 1.1rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #f0f0f0;
  }

  label {
    color: #555;
    font-weight: 500;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    display: block;
  }

  input, select {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    padding: 0.65rem 0.85rem;
    font-size: 0.95rem;
    transition: all 0.3s ease;

    &:focus {
      border-color: #00a651;
      box-shadow: 0 0 0 3px rgba(0, 166, 81, 0.1);
      outline: none;
    }

    &::placeholder {
      color: #999;
    }
  }
`;

export const SearchButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #00a651 0%, #008a44 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 166, 81, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const EmptyState = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 3rem 2rem;
  text-align: center;
  color: #999;

  .empty-icon {
    font-size: 4rem;
    margin-bottom: 1rem;
    opacity: 0.3;
  }

  h5 {
    color: #666;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  p {
    color: #999;
    margin: 0;
  }
`;

export const LoadingState = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 4rem 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  .spinner-border {
    width: 3rem;
    height: 3rem;
    border-width: 0.3rem;
    color: #00a651;
  }

  span {
    color: #666;
    font-weight: 500;
  }
`;

export const AccidentsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const InfoChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  background: ${(props) => (props.$highlight ? '#e8f5e9' : '#f5f5f5')};
  border: 1px solid ${(props) => (props.$highlight ? '#c8e6c9' : '#e8e8e8')};
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: ${(props) => (props.$highlight ? '600' : '500')};
  color: ${(props) => (props.$highlight ? '#2e7d32' : '#666')};
  margin-right: 0.5rem;
  margin-bottom: 0.35rem;
`;
